import React from 'react';
import PropTypes from 'prop-types';
import { truncateNumber, urlEncode } from '../../../utilities/Utils';
import { percentageIndicatorClass, percentageIndicator } from '../../Accounts/Assets/AssetUtils';

const InstrumentDetailsTable = ({ instruments }) => {
    return (
        <table className="table mb-0">
            <thead>
                <tr>
                    <th className="d-table-cell">Security name</th>

                    <th className="text-left">Code</th>

                    <th className="text-right d-table-cell d-lg-none">Price</th>
                    <th className="text-right d-none d-lg-table-cell">Market Value</th>

                    <th className="text-right d-none d-lg-table-cell">High</th>
                    <th className="text-right d-none d-lg-table-cell">Low</th>

                    <th className="text-right combined-values d-table-cell d-lg-none">
                        <span className="text-nowrap mb-0 d-block">Change</span>
                        <span className="change-percentage text-plain text-nowrap d-block d-sm-none mb-0">%</span>
                    </th>
                    <th className="text-right d-none d-lg-table-cell">Change</th>
                    <th className="change-percentage d-none d-sm-table-cell text-right">%</th>
                    <th className="fb-pl-0 fb-pr-0" />
                </tr>
                </thead>
            <tbody>

            {instruments.map((instrument, index) => {
                const { closeValue, highValue, lowValue, changeValue, changePercentage } = instrument;

                return (
                    <tr key={index}>
                        <td className="column-primary">
                            <a href={urlEncode(`${window.location.pathname.replace(/\/$/, '')}/${instrument.instrumentId}`)}>
                                {instrument.name}
                            </a>
                        </td>
                        <td className="text-left">{instrument.tickerSymbol}</td>
                        <td className="text-right">
                            {`${truncateNumber(closeValue.amount)}${closeValue.currency == '%' ? '' : ' '}${closeValue.currency}`}
                        </td>
                        <td className="text-right d-none d-lg-table-cell">
                            {`${truncateNumber(highValue.amount)}${highValue.currency == '%' ? '' : ' '}${highValue.currency}`}
                        </td>
                        <td className="text-right d-none d-lg-table-cell">
                            {`${truncateNumber(lowValue.amount)}${lowValue.currency == '%' ? '' : ' '}${lowValue.currency}`}
                        </td>
                        <td>
                            <div className="text-right d-block">
                                {`${changeValue.amount > 0 ? '+' : ''}${truncateNumber(changeValue.amount)}${changeValue.currency === '%' ? '' : ' '}${changeValue.currency}`}
                            </div>
                            <p className="text-plain text-nowrap change-percentage d-block d-sm-none text-right">
                                {`${changePercentage.toFixed(2)}%`}
                            </p>
                        </td>
                        <td className="d-none d-sm-table-cell change-percentage">
                            {`${(changePercentage > 0) ? '+' : ''}${changePercentage.toFixed(2)}%`}
                        </td>
                        <td className="indicator fb-pl-0 fb-pr-0" width="32">
                            <span className={`${percentageIndicatorClass(percentageIndicator.parse(changePercentage))}`} />
                        </td>
                    </tr>
                );
            })}
            </tbody>
        </table>
    );
};

InstrumentDetailsTable.propTypes = {
    instruments: PropTypes.array,
};

InstrumentDetailsTable.defaultProps = {
    instruments: [],
};

export default InstrumentDetailsTable;
